var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerIconLincoln({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ford_BIS_Icon_Fill_Laptop_Screen_RGB_v1 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.6763 15.0544C55.3219 13.6106 54.0356 12.5475 52.5 12.5475H10.5263C8.715 12.5475 7.245 14.0175 7.245 15.8287V43.89H5.90625C5.18438 43.89 4.59375 44.4806 4.59375 45.2025V47.1844C4.59375 48.9956 6.06375 50.4656 7.875 50.4656H17.325C20.4488 44.2444 25.2525 37.6031 31.4344 31.4212C39.375 23.4806 48.0769 17.7975 55.6763 15.0544Z",
    fill: "#324047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.4062 47.1844V45.2025C58.4062 44.4806 57.8156 43.89 57.0938 43.89H55.7812V15.8156C55.7812 15.5531 55.7419 15.2906 55.6763 15.0413C48.0638 17.7844 39.375 23.4675 31.4213 31.4213C25.2394 37.6031 20.4356 44.2313 17.3119 50.4656H55.125C56.9362 50.4656 58.4062 48.9956 58.4062 47.1844Z",
    fill: "#324047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.1875 15.0938H11.8125C10.7231 15.0938 9.84375 15.9731 9.84375 17.0625V44.5462C9.84375 44.9137 10.1325 45.2025 10.5 45.2025H26.8013C26.8669 45.3994 26.9194 45.6094 26.9194 45.8325V45.8456C26.9194 46.2131 27.2213 46.515 27.5888 46.515H35.4375C35.805 46.515 36.1069 46.2131 36.1069 45.8456V45.8325C36.1069 45.6094 36.1594 45.3994 36.225 45.2025H52.5C52.8675 45.2025 53.1562 44.9137 53.1562 44.5462V17.0625C53.1562 15.9731 52.2769 15.0938 51.1875 15.0938ZM51.8438 43.89H11.1562V17.0625C11.1562 16.695 11.445 16.4062 11.8125 16.4062H51.1875C51.555 16.4062 51.8438 16.695 51.8438 17.0625V43.89Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.4869 28.3632C29.2819 28.3632 27.5231 29.1507 27.5231 30.1482C27.5231 31.1325 29.295 31.9332 31.4869 31.9332C33.6787 31.9332 35.4506 31.1325 35.4506 30.1482C35.4506 29.1638 33.6787 28.3632 31.4869 28.3632Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIconLincoln);
export default __webpack_public_path__ + "static/media/computer-icon-lincoln.e4ef9d29ebe6cfc1263aa1657f694061.svg";
export { ForwardRef as ReactComponent };